module.exports = __webpack_public_path__ + "media/level-complete.c16d5a81.wav";